"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
exports.default = react_jss_1.createUseStyles({
    title: function (_a) {
        var theme = _a.theme, element = _a.element;
        return (__assign(__assign({}, theme_1.getFontStyles(theme)), { fontFamily: theme.headings.fontFamily, fontWeight: theme.headings.fontWeight, fontSize: theme.headings.sizes[element].fontSize, lineHeight: theme.headings.sizes[element].lineHeight, margin: 0, color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.black, '@media (max-width: 755px)': {
                fontSize: typeof theme.headings.sizes[element].fontSize === 'number' &&
                    theme.headings.sizes[element].fontSize / 1.3,
            } }));
    },
}, { link: true });
